import { Component, OnInit, OnDestroy } from '@angular/core';
import { switchMap, tap } from 'rxjs/operators';
import { PagedConsultNoteQueueResults } from '../../../core/services/consult-note-queue.service';
import { BaseConsultNotesComponent } from '../base-consult-notes/base-consult-notes.component';
import { ConsultNoteQueueSettingsComponent } from '../../components/consult-note-queue-settings/consult-note-queue-settings.component';

import { ConsultNoteQueueAssignUserComponent } from '../../../shared/components/consult-note-queue-assign-user/consult-note-queue-assign-user.component';
import { ConsultNoteQueueResultsComponent } from '../../../shared/components/consult-note-queue-results/consult-note-queue-results.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-consult-notes',
  templateUrl: './consult-notes.component.html',
  styleUrls: ['./consult-notes.component.scss'],
  imports: [ConsultNoteQueueSettingsComponent,
    ConsultNoteQueueAssignUserComponent,
    ConsultNoteQueueResultsComponent,
    MatProgressSpinner]
})
export class ConsultNotesComponent extends BaseConsultNotesComponent implements OnInit, OnDestroy {
  protected consultNoteHasBeenSelected(id) {
    this.userPresenceService.subscribeAndJoin('consultNote', id);
  }

  protected consultNoteHasBeenUnselected(id) {
    this.userPresenceService.leaveAndUnsubscribe('consultNote', id);
  }

  protected configureGetResults() {
    this.getResults$
      .pipe(
        tap(() => {
          this.loadingResults = true;
          this.consultNoteQueueResults = [];
          this.userPresenceService.unsubscribeAll();
        }),
        switchMap(() => this.consultNoteQueueService.getResults(this.cursor))
      )
      .subscribe((results: PagedConsultNoteQueueResults) => {
        this.consultNoteQueueResults = results.consultNoteQueueResults;
        this.cursor = results.meta.cursor;
        this.loadingResults = false;
        this.hasMoreResults = !!results.meta.cursor;
        this.subscribeToUserPresence();
      });
  }
}
